<template>
  <div id="app">


    <!-- 1 -->

    <router-view></router-view>

    <!-- 2 -->
    <!-- <transition :name="transitionName">
      <router-view class="transitionBody"></router-view>
    </transition> -->



  </div>
</template>

<script>
import { getJSSDK } from '@/share/wxShare.js'
export default {
  name: 'App',
  data() {
    return {
      transitionName: 'transitionLeft',
    }
  },
  mounted() {
    const url = location.href.split('#')[0];
    const ua = window.navigator.userAgent.toLowerCase();
    // console.log(ua);
    let title = document.title
    // console.log(url, document.title);
    getJSSDK(url, title);
    // // 判断是否为微信浏览器
    // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //   getJSSDK(url); 					//传入sdk.js需要的参数
    // } else {
    //   console.log('不是微信浏览器')
    // }
  },
  methods: {

  },
  watch: {
    // '$route'(to, from) {
    //   const arr = ['/shop-order', '/driver-info', '/shop-info', '/shopOrder-detail', '/change-password']
    //   this.transitionName = arr.indexOf(to.path) > arr.indexOf(from.path) ? 'transitionLeft' : 'transitionRight'
    // }
  }

}
</script>

<style lang='scss' src='../static/reselem.scss'></style>
<style lang='scss' src='../static/waterfall.scss'></style>
<style >
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

ul,
li {
  list-style: none;
}

body {
  overflow-x: hidden;
  /* margin-top: 60px; */
  /* min-width: 800px; */
  font-family: Helvetica, arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  background-color: #f6f6f6;
  /* padding: 10px 70px 10px 70px; */
}



/* // 动画 style样式 */
/* .transitionRouter-enter,
.transitionRouter-leave-to {
  opacity: 0;
}

.transitionRouter-enter-to,
.transitionRouter-leave {
  opacity: 1;
}

.transitionRouter-enter-active,
.transitionRouter-leave-active {
  transition: all 0.5s;
} */

/* 过度动画2 */
/* .fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity .3s;
}

.fade-leave {
  opacity: 1;
}

.fade-leave-active {
  opacity: 0;
  transition: opacity .3s;
} */

/* 过度动画2 */
/* .transitionBody {
  transition: all 0.4s ease-out;
}

.transitionLeft-enter,
.transitionRight-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}

.transitionLeft-leave-active,
.transitionRight-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}

.transitionLeft-enter-active,
.transitionRight-enter-active {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue